import { type SyntheticEvent, useContext } from "react";
import { StyleTypeContext } from "../../../umbilical_tools";
import { JssProvider } from "react-jss";

import {
  MSFNavBtn as MSFNavBtnEasy,
  Button as ButtonEasy,
  SearchButton as SearchButtonEasy,
} from "./brands/easy";
import { MSFNavBtn as MSFNavBtnTmdh } from "./brands/tmdh";
import { MSFNavBtn as MSFNavBtnInfinite } from "./brands/infinite";
import { MSFNavBtn as MSFNavBtnRocs } from "./brands/rocs";
import { MSFNavBtn as MSFNavBtnFightzone } from "./brands/fightzone";
import { MSFNavBtn as MSFNavBtnFlymenow } from "./brands/flymenow";
import { MSFNavBtn as MSFNavBtnOasis } from "./brands/oasis";
import { MSFNavBtn as MSFNavBtnGreecetrips } from "./brands/greecetrips";
import { MSFNavBtn as MSFNavBtnInnstanttravel } from "./brands/innstanttravel";
import {
  MSFNavBtn as MSFNavBtnUab,
  Button as ButtonUab,
  SearchButton as SearchButtonUab,
} from "./brands/uab";
import {
  MSFNavBtn as MSFNavBtnMytravellifestyle,
  Button as ButtonMytravellifestyle,
  SearchButton as SearchButtonMytravellifestyle,
} from "./brands/mytravellifestyle";
import {
  MSFNavBtn as MSFNavBtnHgv,
  Button as ButtonHgv,
  SearchButton as SearchButtonHgv,
} from "./brands/hgv";
import {
  MSFNavBtn as MSFNavBtnKemet,
  Button as ButtonKemet,
  SearchButton as SearchButtonKemet,
} from "./brands/kemet";

type ButtonProps = {
  id?: string;
  text: string;
  revert?: boolean;
  empty?: boolean;
  onClick?: (e: SyntheticEvent) => void;
  type?: string;
  showIcon?: boolean;
  icon?: string;
  loading?: boolean;
  ghost?: boolean;
  size?: string;
  bold?: boolean;
  customStyles?: Record<string, unknown>;
};
export function Button(props: ButtonProps) {
  const { brand } = useContext(StyleTypeContext);

  let Comp = ButtonEasy;
  switch (brand) {
    case "easy":
      Comp = ButtonEasy;
      break;
    case "uab":
      Comp = ButtonUab;
      break;
    case "mytravellifestyle":
      Comp = ButtonMytravellifestyle;
      break;
    case "hgv":
      Comp = ButtonHgv;
      break;
    case "kemet":
      Comp = ButtonKemet;
      break;
    default:
      Comp = ButtonEasy;
      break;
  }

  return (
    <JssProvider classNamePrefix={`${brand}--`}>
      <Comp {...props} />
    </JssProvider>
  );
}

export function SearchButton(props: any) {
  const { brand } = useContext(StyleTypeContext);

  switch (brand) {
    case "easy":
      return <SearchButtonEasy {...props} />;
    case "uab":
      return <SearchButtonUab {...props} />;
    case "mytravellifestyle":
      return <SearchButtonMytravellifestyle {...props} />;
    case "hgv":
      return <SearchButtonHgv {...props} />;
    case "kemet":
      return <SearchButtonKemet {...props} />;
    default:
      return <SearchButtonEasy {...props} />;
  }
}

export const MSFNavButton = (props: any) => {
  const { brand } = useContext(StyleTypeContext);

  switch (brand) {
    case "easy":
      return <MSFNavBtnEasy {...props} />;
    case "tmdh":
      return <MSFNavBtnTmdh {...props} />;
    case "rocs":
      return <MSFNavBtnRocs {...props} />;
    case "infinite":
      return <MSFNavBtnInfinite {...props} />;
    case "fightzone":
      return <MSFNavBtnFightzone {...props} />;
    case "flymenow":
      return <MSFNavBtnFlymenow {...props} />;
    case "oasis":
      return <MSFNavBtnOasis {...props} />;
    case "greecetrips":
      return <MSFNavBtnGreecetrips {...props} />;
    case "innstanttravel":
      return <MSFNavBtnInnstanttravel {...props} />;
    case "uab":
      return <MSFNavBtnUab {...props} />;
    case "mytravellifestyle":
      return <MSFNavBtnMytravellifestyle {...props} />;
    case "hgv":
      return <MSFNavBtnHgv {...props} />;
    case "kemet":
      return <MSFNavBtnKemet {...props} />;

    default:
      return <MSFNavBtnEasy {...props} />;
  }
};
